import { axiosSetting } from '@/utils/axiosSetting'
import { inject, provide, reactive } from 'vue'
import {
  MagazineSpecialRecommendState,
  MagazineSpecialRecommendResponse,
  UseRecommend
} from '@/types/MagazineRecommend'

const axios = axiosSetting(
  'cms',
  'block',
  `${process.env.VUE_APP_WPAPI_URL}/wp-json/mynaviresident/v1/`
)
export const createRecommend = () => {
  const recommendState = reactive<MagazineSpecialRecommendState>({
    allRecommends: [],
    specialRecommends: [],
    seriesRecommends: []
  })

  const loadRecommends = async (): Promise<void> => {
    const { data } = await axios.get('/recommend')
    const response: MagazineSpecialRecommendResponse = data
    console.log('recommends', response.data)

    const allRecommends = response.data.map((recommend) => {
      if (recommend.post_type === 'test') {
        // 国試マスター
        return {
          id: recommend.id,
          title: '1日1問！国試マスター',
          description: recommend.post_excerpt,
          category: recommend.post_type_label,
          parentCategory: '',
          imageUrl: require('@/assets/images/magazines/master_thumb.png') as string,
          imageAlt: '1日1問！国試マスター',
          path: '/magazines/exam/master',
          membershipOnly: true,
          externalLinkUrl: recommend.external_link
            ? recommend.external_link
            : '',
          isPr: recommend.is_pr === '1',
          recommendFlags: recommend.recommend_flags || []
        }
      }
      if (recommend.post_type === 'cbt') {
        // cbt模擬試験
        return {
          id: recommend.id,
          title: '全国一斉CBT模擬試験',
          description: recommend.post_excerpt,
          category: recommend.post_type_label,
          parentCategory: '',
          imageUrl: require('@/assets/images/magazines/cbt_2025_thumb.png') as string,
          imageAlt: '全国一斉CBT模擬試験',
          path: '/magazines/exam/cbt',
          membershipOnly: true,
          externalLinkUrl: recommend.external_link
            ? recommend.external_link
            : '',
          isPr: recommend.is_pr === '1',
          recommendFlags: recommend.recommend_flags || []
        }
      }

      return {
        id: recommend.id,
        title: recommend.post_title,
        description: recommend.post_excerpt,
        category: recommend.post_type_label,
        parentCategory: recommend.parent_category ?? '',
        imageUrl:
          recommend.thumbnail_url ??
          (require('@/assets/images/common/noimg.svg') as string),
        imageAlt: recommend.thumbnail_alt ?? '',
        path: recommend.path,
        membershipOnly: recommend.members_only_flag === '1',
        externalLinkUrl: recommend.external_link ? recommend.external_link : '',
        isPr: recommend.is_pr === '1',
        recommendFlags: recommend.recommend_flags || []
      }
    })
    // 連載のおすすめは
    // 「連載」カテゴリ且つ「レコメンド重みづけ特別加算フラグ」が指定されているスペシャルコンテンツ
    // NOTE: ホームに必要な処理はgetHomeSeriesTopRecommendsで行う。ここでは既存の動作を尊重して「連載」カテゴリの取り出しのみ行う
    const seriesRecommends = allRecommends.filter(
      (recommend) => recommend.parentCategory === 'series'
    )
    // スペシャルコンテンツのおすすめは
    // 「スペシャルコンテンツ」カテゴリ且つ「レコメンド重みづけ特別加算フラグ」が指定されているスペシャルコンテンツ、研修病院選びの基礎知識、試験対策、進級試験対策、ご利用ガイド
    const specialRecommends = allRecommends.filter(
      (recommend) =>
        recommend.parentCategory === 'special' ||
        recommend.category === '試験対策' ||
        recommend.category === '進級試験対策' ||
        recommend.title === 'ご利用ガイド' ||
        recommend.title === '研修病院選びの基礎知識'
    )
    recommendState.allRecommends = [...seriesRecommends, ...specialRecommends]
    recommendState.seriesRecommends = seriesRecommends
    recommendState.specialRecommends = specialRecommends
  }

  // getters

  const getHomeSpecialRecommends = () => {
    return recommendState.specialRecommends.slice(0, 12)
  }

  // NOTE: 「連載」カテゴリーのおすすめから「優先度高」「有料」フラグを持つものを抽出
  const getHomeSeriesTopRecommends = () => {
    return recommendState.seriesRecommends.filter((item) => {
      if (!item.recommendFlags || !item.recommendFlags.length) return false
      return (
        item.recommendFlags.includes('優先度高') ||
        item.recommendFlags.includes('有料')
      )
    })
  }

  return {
    recommendState,
    loadRecommends,
    getHomeSpecialRecommends,
    getHomeSeriesTopRecommends
  }
}

export const key = Symbol()
export const provideRecommend = () => provide(key, createRecommend())
export const useRecommend = () => inject(key) as UseRecommend
